import React from "react";
import { ArrowUp, ArrowDown } from "lucide-react";

const RuleTableHead = ({
  sortColumn,
  sortOrder,
  handleSort,
  columnSearch,
  onSearchSubmit,
  onColumnSearchChange,
}) => {
  return (
    <thead className="bg-[#9897FF1A] text-[#404040]">
      <tr>
        <th
          onClick={() => handleSort("data_product_name")}
          className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
        >
          <span className={`flex items-center gap-1 ${sortColumn === "data_product_name" ? "text-[#bb1ccc]" : ""}`}>
            Data Product Name
            {sortColumn === "data_product_name" ? (sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />) : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("data_asset_name")}
          className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
        >
          <span className={`flex items-center gap-1 ${sortColumn === "data_asset_name" ? "text-[#bb1ccc]" : ""}`}>
            Data Asset Name
            {sortColumn === "data_asset_name" ? (sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />) : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("rule_name")}
          className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
        >
          <span className={`flex items-center gap-1 ${sortColumn === "rule_name" ? "text-[#bb1ccc]" : ""}`}>
            Rule Name
            {sortColumn === "rule_name" ? (sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />) : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("rule_description")}
          className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
        >
          <span className={`flex items-center gap-1 ${sortColumn === "rule_description" ? "text-[#bb1ccc]" : ""}`}>
            Rule Description
            {sortColumn === "rule_description" ? (sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />) : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("check_name")}
          className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
        >
          <span className={`flex whitespace-nowrap items-center gap-1 ${sortColumn === "check_name" ? "text-[#bb1ccc]" : ""}`}>
            Check Name
            {sortColumn === "check_name" ? (sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />) : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("dimension_name")}
          className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
        >
          <span className={`flex items-center gap-1 ${sortColumn === "dimension_name" ? "text-[#bb1ccc]" : ""}`}>
            Dimension Name
            {sortColumn === "dimension_name" ? (sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />) : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("total_row_count")}
          className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
        >
          <span className={`flex items-center gap-1 ${sortColumn === "total_row_count" ? "text-[#bb1ccc]" : ""}`}>
            Total Rows
            {sortColumn === "total_row_count" ? (sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />) : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("error_record_count")}
          className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
        >
          <span className={`flex items-center gap-1 ${sortColumn === "error_record_count" ? "text-[#bb1ccc]" : ""}`}>
            Error Rows
            {sortColumn === "error_record_count" ? (sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />) : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("quality_score")}
          className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
        >
          <span className={`flex items-center gap-1 ${sortColumn === "quality_score" ? "text-[#bb1ccc]" : ""}`}>
            Quality Score
            {sortColumn === "quality_score" ? (sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />) : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("execution_date")}
          className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
        >
          <span className={`flex items-center gap-1 ${sortColumn === "execution_date" ? "text-[#bb1ccc]" : ""}`}>
            Execution Date
            {sortColumn === "execution_date" ? (sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />) : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>
      </tr>

      <tr>
        <th className="px-4 pt-0 pb-[10px]">
          <input value={columnSearch.data_product_name || ""}
           onChange={(e) => onColumnSearchChange("data_product_name", e.target.value)} 
           onKeyDown={(e) => {
    if (e.key === 'Enter') {
      onSearchSubmit("data_product_name", e.target.value);
    }
  }}
          className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none" placeholder="Search " />
        </th>

        <th className="px-4 pt-0 pb-[10px]">
          <input value={columnSearch.data_asset_name || ""} onChange={(e) => onColumnSearchChange("data_asset_name", e.target.value)} 
          onKeyDown={(e) => {
    if (e.key === 'Enter') {
      onSearchSubmit("data_asset_name", e.target.value);
    }
  }}
          className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none" placeholder="Search" />
        </th>

        <th className="px-4 pt-0 pb-[10px]">
          <input value={columnSearch.rule_name || ""} onChange={(e) => onColumnSearchChange("rule_name", e.target.value)}
          onKeyDown={(e) => {
    if (e.key === 'Enter') {
      onSearchSubmit("rule_name", e.target.value);
    }
  }} className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none" placeholder="Search " />
        </th>

        <th className="px-4 pt-0 pb-[10px]">
          <input value={columnSearch.rule_description || ""} onChange={(e) => onColumnSearchChange("rule_description", e.target.value)}
          onKeyDown={(e) => {
    if (e.key === 'Enter') {
      onSearchSubmit("rule_description", e.target.value);
    }
  }}
          className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none" placeholder="Search " />
        </th>

        <th className="px-4 pt-0 pb-[10px]">
          <input value={columnSearch.check_name || ""} onChange={(e) => onColumnSearchChange("check_name", e.target.value)} 
          onKeyDown={(e) => {
    if (e.key === 'Enter') {
      onSearchSubmit("check_name", e.target.value);
    }
  }}
          className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none" placeholder="Search " />
        </th>

        <th className="px-4 pt-0 pb-[10px]">
          <input value={columnSearch.dimension_name || ""} onChange={(e) => onColumnSearchChange("dimension_name", e.target.value)} 
          onKeyDown={(e) => {
    if (e.key === 'Enter') {
      onSearchSubmit("dimension_name", e.target.value);
    }
  }}
          className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none" placeholder="Search" />
        </th>

        <th className="px-4 pt-0 pb-[10px]">
          <input value={columnSearch.total_row_count || ""} onChange={(e) => onColumnSearchChange("total_row_count", e.target.value)}
          onKeyDown={(e) => {
    if (e.key === 'Enter') {
      onSearchSubmit("total_row_count", e.target.value);
    }
  }} className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none" placeholder="Search " />
        </th>

        <th className="px-4 pt-0 pb-[10px]">
          <input
            value={columnSearch.error_record_count || ""}
            onChange={(e) => onColumnSearchChange("error_record_count", e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onSearchSubmit("error_record_count", e.target.value);
              }
            }}
            className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
            placeholder="Search Error Rows"
          />
        </th>

        <th className="px-4 pt-0 pb-[10px]">
          <input value={columnSearch.quality_score || ""} onChange={(e) => onColumnSearchChange("quality_score", e.target.value)} 
           onKeyDown={(e) => {
    if (e.key === 'Enter') {
      onSearchSubmit("quality_score", e.target.value);
    }
  }}
          className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none" placeholder="Search " />
        </th>

        <th className="px-4 pt-0 pb-[10px]">
          <input value={columnSearch.execution_date || ""} onChange={(e) => onColumnSearchChange("execution_date", e.target.value)} 
           onKeyDown={(e) => {
    if (e.key === 'Enter') {
      onSearchSubmit("execution_date", e.target.value);
    }
  }}
          className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none" placeholder="Search " />
        </th>
      </tr>
    </thead>
  );
};

export default RuleTableHead;
